class Utils {
  // Get first character from first & last sentences of a username
  static getNameInitial(name) {
    let initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  }

  // Get current path related object from Navigation Tree
  static getRouteInfo(navTree, path) {
    if (navTree.path === path) {
      return navTree;
    }
    let route;
    for (let p in navTree) {
      if (navTree.hasOwnProperty(p) && typeof navTree[p] === 'object') {
        route = this.getRouteInfo(navTree[p], path);
        if (route) {
          return route;
        }
      }
    }
    return route;
  }

  // Get accessible color contrast
  static getColorContrast(hex) {
    if (!hex) {
      return 'dark';
    }
    const threshold = 130;
    const hRed = hexToR(hex);
    const hGreen = hexToG(hex);
    const hBlue = hexToB(hex);
    function hexToR(h) {
      return parseInt(cutHex(h).substring(0, 2), 16);
    }
    function hexToG(h) {
      return parseInt(cutHex(h).substring(2, 4), 16);
    }
    function hexToB(h) {
      return parseInt(cutHex(h).substring(4, 6), 16);
    }
    function cutHex(h) {
      return h.charAt(0) === '#' ? h.substring(1, 7) : h;
    }
    const cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
    if (cBrightness > threshold) {
      return 'dark';
    } else {
      return 'light';
    }
  }

  // Darken or lighten a hex color
  static shadeColor(color, percent) {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);
    R = parseInt((R * (100 + percent)) / 100);
    G = parseInt((G * (100 + percent)) / 100);
    B = parseInt((B * (100 + percent)) / 100);
    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;
    const RR =
      R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
    const GG =
      G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
    const BB =
      B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);
    return `#${RR}${GG}${BB}`;
  }

  // Convert RGBA to HEX
  static rgbaToHex(rgba) {
    const trim = (str) => str.replace(/^\s+|\s+$/gm, '');
    const inParts = rgba.substring(rgba.indexOf('(')).split(','),
      r = parseInt(trim(inParts[0].substring(1)), 10),
      g = parseInt(trim(inParts[1]), 10),
      b = parseInt(trim(inParts[2]), 10),
      a = parseFloat(
        trim(inParts[3].substring(0, inParts[3].length - 1))
      ).toFixed(2);
    const outParts = [
      r.toString(16),
      g.toString(16),
      b.toString(16),
      Math.round(a * 255)
        .toString(16)
        .substring(0, 2),
    ];

    outParts.forEach(function (part, i) {
      if (part.length === 1) {
        outParts[i] = '0' + part;
      }
    });
    return `#${outParts.join('')}`;
  }

  // Returns either a positive or negative
  static getSignNum(number, positive, negative) {
    if (number > 0) {
      return positive;
    }
    if (number < 0) {
      return negative;
    }
    return null;
  }

  // Returns either ascending or descending value
  static antdTableSorter(a, b, key) {
    if (typeof a[key] === 'number' && typeof b[key] === 'number') {
      return a[key] - b[key];
    }

    if (typeof a[key] === 'string' && typeof b[key] === 'string') {
      a = a[key].toLowerCase();
      b = b[key].toLowerCase();
      return a > b ? -1 : b > a ? 1 : 0;
    }
    return;
  }

  // Filter array of object
  static filterArray(list, key, value) {
    let data = list;
    if (list) {
      data = list.filter((item) => item[key] === value);
    }
    return data;
  }

  // Remove object from array by value
  static deleteArrayRow(list, key, value) {
    let data = list;
    if (list) {
      data = list.filter((item) => item[key] !== value);
    }
    return data;
  }

  // Wild card search on all property of the object
  static wildCardSearch(list, input) {
    const searchText = (item) => {
      for (let key in item) {
        if (item[key] == null) {
          continue;
        }
        if (
          item[key]
            .toString()
            .toUpperCase()
            .indexOf(input.toString().toUpperCase()) !== -1
        ) {
          return true;
        }
      }
    };
    list = list.filter((value) => searchText(value));
    return list;
  }

  // Get Breakpoint
  static getBreakPoint(screens) {
    let breakpoints = [];
    for (const key in screens) {
      if (screens.hasOwnProperty(key)) {
        const element = screens[key];
        if (element) {
          breakpoints.push(key);
        }
      }
    }
    return breakpoints;
  }

  // Get window size
  static getWindowSize() {
    const width = window.innerWidth;
    if (width < 576) {
      return 'xs';
    }
    if (width < 768) {
      return 'sm';
    }
    if (width < 992) {
      return 'md';
    }
    if (width < 1200) {
      return 'lg';
    }
    return 'xl';
  }

  // Split title to multiple line based on the window size
  static splitTitle(title) {
    const size = this.getWindowSize();
    if (size === 'xl') {
      return title;
    }

    // Check for date-time format like "02/07/2025 03:07 PM"
    const dateTimeRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2} [AP]M$/;
    if (dateTimeRegex.test(title)) {
      const [date, hour, minute, meridiem] = title.split(/[\s:]/);
      const datePart = date;
      const timePart = `${hour}:${minute} ${meridiem}`;
      return (
        <>
          {datePart} <br /> {timePart}
        </>
      );
    }

    // Handle cases like "Adjustment (%)", "Charges RM", "Adjustment %", "Charges (RM)"
    const specialPattern = /^(.*)\s((\([^)]+\))|[%$€£¥₩₹]+|RM)$/i;
    const matchSpecial = title.match(specialPattern);
    if (matchSpecial) {
      const firstPart = matchSpecial[1];
      const lastPart = matchSpecial[2];
      return (
        <>
          {firstPart} <br /> {lastPart}
        </>
      );
    }

    // Handle cases like "Buy Adjustment %", "Buy Adjustment (%)", etc.
    // If the last word is a symbol or in parentheses, keep it together in the first line
    const match = title.match(/^(.*?)(\s+(\([^)]+\)|[%$€£¥₩₹]+|RM))$/i);
    if (match) {
      const words = title.trim().split(' ');
      if (
        words.length > 2 &&
        /%|\([^)]+\)|RM|[$€£¥₩₹]+/i.test(words[words.length - 1])
      ) {
        const firstPart = words.slice(0, words.length - 2).join(' ');
        const secondPart = words.slice(words.length - 2).join(' ');
        return (
          <>
            {firstPart} <br /> {secondPart}
          </>
        );
      }
      // fallback to default
    }

    // Otherwise, split evenly
    const splittedTitle = title.split(' ');
    const halfIndex = Math.ceil(splittedTitle.length / 2);
    const firstHalf = splittedTitle.slice(0, halfIndex).join(' ');
    const secondHalf = splittedTitle.slice(halfIndex).join(' ');
    return (
      <>
        {firstHalf} <br /> {secondHalf}
      </>
    );
  }

  // Check user privileges
  static checkUserPrivileges(privilegeToCheck) {
    const profile = JSON.parse(sessionStorage.getItem('profile'));
    const privileges = profile?.Privileges ? profile.Privileges : [];

    if (privileges && privileges.includes(privilegeToCheck)) {
      return true;
    } else {
      return false;
    }
  }
}

export default Utils;
